<template>
  <div class="salesfunnel">
    <CardComponent>
      <template v-slot:title>Sales Funnel</template>
      <span class="salesfunnel--menu" v-if="showDropdownMenu" @click="showDropdown = !showDropdown">&vellip;</span>

      <ToolTip>
        <template v-slot:title>
          Tooltip Title
        </template>
        <p>
          Dies ist ein Typoblindtext. An ihm kann man sehen, ob alle Buchstaben da sind und wie sie aussehen.
        </p>
        <p>
          Manchmal benutzt man Worte wie Hamburgefonts, Rafgenduks oder Handgloves, um Schriften zu testen. Manchmal Sätze, die alle Buchstaben des Alphabets enthalten - man nennt diese Sätze »Pangrams«. Sehr bekannt ist dieser: The
        </p>
      </ToolTip>

      <div
        class="salesfunnel--dropdown"
        :class="{show: showDropdown}"
        v-click-outside="{
          handler: () => {showDropdown = false},
          closeConditional: () => showDropdown
        }">
        <slot :closeDropdown="closeDropdown"></slot>
      </div>

      <div class="flex-wrapper">
        <section class="titles">
          <span class="item--title" v-for='item in items' :key="item.id">{{ item.title }}</span>
        </section>

        <FunnelDiagram 
            :items="items" 
            :full_width="280"
            :bottom_width="60"
            :element_height="34"
            :gap="18"
            class="funnel-diagram" />

        <section class="values">
          <span class="value--title" v-for='item in items' :key="item.id">{{ item.value }}</span>
        </section>        
      </div>

      <footer>Sales-Funnel der Conversion-Rates pro Stufe zeigt. (+ gesamt Lead-to-Sale Conversion)</footer>

    </CardComponent>
  </div>
</template>

<script>
import {ref} from "@vue/composition-api";
import CardComponent from "@/components/form/CardComponent";
import FunnelDiagram from "@/components/lead/marketplace/funnel/FunnelDiagram";
import ToolTip from "@/components/info/ToolTip";

export default {

  name: 'SalesFunnel',
  components:{
    CardComponent,
    FunnelDiagram,
    ToolTip
  },
 
  props:{
    showDropdownMenu: {
      type: Boolean,
      default: true
    },
    items:{
      type: Array,
      default: () => []
    }
  },

  setup(){
    const showDropdown = ref(false);

    function closeDropdown(){
      showDropdown.value = false;
    }

    return {showDropdown, closeDropdown};
  }
}
</script>

<style lang="scss" scoped>

  .salesfunnel{
    position: relative;
    
    .titles, .values{
      display: flex;
      flex-direction: column-reverse;
      width: 250px;
      padding-bottom: $spacer * 2;
    }

    .titles{
      margin-left: $spacer;
    }

    .values{
      margin-right: $spacer;
      text-align: right;
    }

    .item--title, .value--title{
      display: block;
      line-height: 24px;
      padding: 15px 0 7px;
      margin-top: 3.5px;
      
      border-bottom: 1px solid map-get($grey, 'lighten-4');
    }      

    .flex-wrapper{
      display: flex;
      justify-content: space-between;
    }

    .funnel-diagram{
      position: absolute;
      left: 50%;
      top: 62px;
      transform: translate(-50%, 0);
    }

    footer{
      text-align: center;
      padding: $spacer;
      color: map-get($grey, 'lighten-blue-1');
    }

    .tooltip{
      position: absolute;
      top: 3px;
      right: 40px;
    }

    .salesfunnel--menu {
      position: absolute;
      top: 0;
      right: 8px;
      padding: 9px;
      cursor: pointer;
    }

    .salesfunnel--dropdown {
      position: absolute;
      min-width: 100px;
      min-height: 100px;
      left: calc(100% - 22px);
      top: 9px;
      background-color: white;
      z-index: 1;
      display: none;

      &.show {
        display: inherit;
      }

    }    
    
  }
</style>

<style lang="scss">
  .salesfunnel{
    font-size: 17px;
    
    .titles, .values{
      color: map-get($grey, 'darken-1') !important;
    }
    
    .v-card__title{
      text-transform: none !important;
      font-size: 18px !important;
      font-weight: normal !important;
      color: map-get($grey, 'dark') !important;
    }    
  }
  
</style>